import { cn } from "../../utils/cn";

export const UEDITOR_PROSEMIRROR_CLASS_NAME = cn(
  "prose prose-sm sm:prose dark:prose-invert max-w-none",
  "focus:outline-none",
  "px-4 py-4",
  "[&_.is-editor-empty]:before:content-[attr(data-placeholder)]",
  "[&_.is-editor-empty]:before:text-muted-foreground/50",
  "[&_.is-editor-empty]:before:float-left",
  "[&_.is-editor-empty]:before:pointer-events-none",
  "[&_.is-editor-empty]:before:h-0",
  "[&_.ProseMirror-gapcursor]:pointer-events-none",
  "[&_.ProseMirror-gapcursor]:absolute",
  "[&_.ProseMirror-gapcursor]:hidden",
  "[&_.ProseMirror-gapcursor:after]:content-['']",
  "[&_.ProseMirror-gapcursor:after]:block",
  "[&_.ProseMirror-gapcursor:after]:absolute",
  "[&_.ProseMirror-gapcursor:after]:top-[-2px]",
  "[&_.ProseMirror-gapcursor:after]:w-8",
  "[&_.ProseMirror-gapcursor:after]:border-t-2",
  "[&_.ProseMirror-gapcursor:after]:border-primary",
  "[&.ProseMirror-focused_.ProseMirror-gapcursor]:block",
  "[&_ul[data-type='taskList']]:list-none",
  "[&_ul[data-type='taskList']]:pl-0",
  "[&_ul[data-type='taskList']_li]:flex",
  "[&_ul[data-type='taskList']_li]:items-start",
  "[&_ul[data-type='taskList']_li]:gap-2",
  "[&_ul[data-type='taskList']_li>label]:mt-0.5",
  "[&_ul[data-type='taskList']_li>label>input]:w-4",
  "[&_ul[data-type='taskList']_li>label>input]:h-4",
  "[&_ul[data-type='taskList']_li>label>input]:rounded",
  "[&_ul[data-type='taskList']_li>label>input]:border-2",
  "[&_ul[data-type='taskList']_li>label>input]:border-primary/50",
  "[&_ul[data-type='taskList']_li>label>input]:accent-primary",
  "[&_pre]:bg-muted/40!",
  "[&_pre]:text-foreground!",
  "[&_pre]:border!",
  "[&_pre]:border-border/60!",
  "[&_pre_code]:bg-transparent!",
  "[&_.tableWrapper]:overflow-x-auto",
  "[&_.tableWrapper]:pb-1.5",
  "[&_.tableWrapper]:select-text",
  "[&_.tableWrapper]:[scrollbar-width:thin]",
  "[&_.tableWrapper]:[scrollbar-color:hsl(var(--border))_transparent]",
  "[&_.tableWrapper::-webkit-scrollbar]:h-2",
  "[&_.tableWrapper::-webkit-scrollbar]:w-2",
  "[&_.tableWrapper::-webkit-scrollbar-track]:rounded-full",
  "[&_.tableWrapper::-webkit-scrollbar-track]:bg-transparent",
  "[&_.tableWrapper::-webkit-scrollbar-thumb]:rounded-full",
  "[&_.tableWrapper::-webkit-scrollbar-thumb]:border",
  "[&_.tableWrapper::-webkit-scrollbar-thumb]:border-solid",
  "[&_.tableWrapper::-webkit-scrollbar-thumb]:border-transparent",
  "[&_.tableWrapper::-webkit-scrollbar-thumb]:bg-border/70",
  "[&_.tableWrapper::-webkit-scrollbar-thumb:hover]:bg-muted-foreground/45",
  "[&_table]:w-auto",
  "[&_table]:table-fixed",
  "[&_table]:overflow-hidden",
  "[&_table]:select-text",
  "[&_table[data-table-align]]:w-max",
  "[&_table[data-table-align]]:max-w-full",
  "[&_table[data-table-align='center']]:mx-auto",
  "[&_table[data-table-align='right']]:ml-auto",
  "[&_table[data-table-align='right']]:mr-0",
  "[&_td]:relative",
  "[&_td]:align-top",
  "[&_td]:box-border",
  "[&_td]:select-text",
  "[&_td]:px-2",
  "[&_td]:py-0",
  "[&_td_p]:my-0",
  "[&_th]:relative",
  "[&_th]:align-top",
  "[&_th]:box-border",
  "[&_th]:select-text",
  "[&_th]:px-2",
  "[&_th]:py-0",
  "[&_th_p]:my-0",
  "[&_td[data-formula]]:pr-7",
  "[&_th[data-formula]]:pr-7",
  "[&_td[data-formula]]:before:pointer-events-none",
  "[&_th[data-formula]]:before:pointer-events-none",
  "[&_td[data-formula]]:before:absolute",
  "[&_th[data-formula]]:before:absolute",
  "[&_td[data-formula]]:before:right-1",
  "[&_th[data-formula]]:before:right-1",
  "[&_td[data-formula]]:before:top-1",
  "[&_th[data-formula]]:before:top-1",
  "[&_td[data-formula]]:before:z-[1]",
  "[&_th[data-formula]]:before:z-[1]",
  "[&_td[data-formula]]:before:rounded-sm",
  "[&_th[data-formula]]:before:rounded-sm",
  "[&_td[data-formula]]:before:bg-primary/10",
  "[&_th[data-formula]]:before:bg-primary/10",
  "[&_td[data-formula]]:before:px-1",
  "[&_th[data-formula]]:before:px-1",
  "[&_td[data-formula]]:before:font-mono",
  "[&_th[data-formula]]:before:font-mono",
  "[&_td[data-formula]]:before:text-[9px]",
  "[&_th[data-formula]]:before:text-[9px]",
  "[&_td[data-formula]]:before:font-semibold",
  "[&_th[data-formula]]:before:font-semibold",
  "[&_td[data-formula]]:before:leading-4",
  "[&_th[data-formula]]:before:leading-4",
  "[&_td[data-formula]]:before:text-primary",
  "[&_th[data-formula]]:before:text-primary",
  "[&_td[data-formula]]:before:content-['fx']",
  "[&_th[data-formula]]:before:content-['fx']",
  "[&_td[data-formula-state='error']]:bg-destructive/5",
  "[&_th[data-formula-state='error']]:bg-destructive/5",
  "[&_td[data-formula-state='error']]:before:bg-destructive/10",
  "[&_th[data-formula-state='error']]:before:bg-destructive/10",
  "[&_td[data-formula-state='error']]:before:text-destructive",
  "[&_th[data-formula-state='error']]:before:text-destructive",
  "[&_td[colwidth]]:min-w-0",
  "[&_th[colwidth]]:min-w-0",
  "[&_td[data-colwidth]]:min-w-0",
  "[&_th[data-colwidth]]:min-w-0",
  "[&_.selectedCell]:after:content-['']",
  "[&_.selectedCell]:after:absolute",
  "[&_.selectedCell]:after:inset-0",
  "[&_.selectedCell]:after:z-[2]",
  "[&_.selectedCell]:after:bg-primary/15",
  "[&_.selectedCell]:after:pointer-events-none",
  "[&_.column-resize-handle]:pointer-events-auto",
  "[&_.column-resize-handle]:cursor-col-resize",
  "[&_.column-resize-handle]:absolute",
  "[&_.column-resize-handle]:top-[-1px]",
  "[&_.column-resize-handle]:bottom-[-1px]",
  "[&_.column-resize-handle]:right-[-5px]",
  "[&_.column-resize-handle]:z-30",
  "[&_.column-resize-handle]:w-2.5",
  "[&_.column-resize-handle]:bg-transparent",
  "[&_.column-resize-handle]:rounded-none",
  "[&_.column-resize-handle]:opacity-0",
  "[&_.column-resize-handle]:transition-opacity",
  "[&_.column-resize-handle]:after:absolute",
  "[&_.column-resize-handle]:after:top-0",
  "[&_.column-resize-handle]:after:bottom-0",
  "[&_.column-resize-handle]:after:left-1/2",
  "[&_.column-resize-handle]:after:w-0.5",
  "[&_.column-resize-handle]:after:-translate-x-1/2",
  "[&_.column-resize-handle]:after:rounded-full",
  "[&_.column-resize-handle]:after:bg-primary/75",
  "[&_.column-resize-handle]:after:content-['']",
  "[&.resize-cursor_.column-resize-handle]:opacity-100",
  "[&.resize-cursor_.column-resize-handle]:after:bg-primary",
  "[&_.column-resize-dragging]:min-w-0",
  "[&.resize-cursor]:cursor-col-resize",
  "[&.resize-row-cursor]:cursor-row-resize",
  "[&_img.ProseMirror-selectednode]:ring-2",
  "[&_img.ProseMirror-selectednode]:ring-primary/60",
  "[&_img.ProseMirror-selectednode]:ring-offset-2",
  "[&_img.ProseMirror-selectednode]:ring-offset-background",
  "[&_hr]:border-t-2",
  "[&_hr]:border-primary/30",
  "[&_hr]:my-8",
  "[&_h1]:text-3xl",
  "[&_h1]:font-bold",
  "[&_h1]:mt-6",
  "[&_h1]:mb-4",
  "[&_h1]:text-foreground",
  "[&_h2]:text-2xl",
  "[&_h2]:font-semibold",
  "[&_h2]:mt-5",
  "[&_h2]:mb-3",
  "[&_h2]:text-foreground",
  "[&_h3]:text-xl",
  "[&_h3]:font-semibold",
  "[&_h3]:mt-4",
  "[&_h3]:mb-2",
  "[&_h3]:text-foreground",
  "[&_ul:not([data-type='taskList'])]:list-disc",
  "[&_ul:not([data-type='taskList'])]:pl-6",
  "[&_ul:not([data-type='taskList'])]:my-3",
  "[&_ol]:list-decimal",
  "[&_ol]:pl-6",
  "[&_ol]:my-3",
  "[&_li]:my-1",
  "[&_li]:pl-1",
  "[&_li_p]:my-0",
  "[&_blockquote]:border-l-4",
  "[&_blockquote]:border-primary",
  "[&_blockquote]:pl-4",
  "[&_blockquote]:py-2",
  "[&_blockquote]:my-4",
  "[&_blockquote]:bg-muted/30",
  "[&_blockquote]:rounded-r-lg",
  "[&_blockquote]:italic",
  "[&_blockquote]:text-muted-foreground",
  "[&_blockquote_p]:my-0",
  "[&_[data-image-layout='left']+p]:mt-1",
  "[&_[data-image-layout='left']+p]:min-h-[5rem]",
  "[&_[data-image-layout='right']+p]:mt-1",
  "[&_[data-image-layout='right']+p]:min-h-[5rem]",
  "max-md:[&_[data-image-layout='left']]:float-none",
  "max-md:[&_[data-image-layout='left']]:mr-0",
  "max-md:[&_[data-image-layout='left']]:ml-0",
  "max-md:[&_[data-image-layout='left']]:max-w-full",
  "max-md:[&_[data-image-layout='right']]:float-none",
  "max-md:[&_[data-image-layout='right']]:mr-0",
  "max-md:[&_[data-image-layout='right']]:ml-0",
  "max-md:[&_[data-image-layout='right']]:max-w-full",
  "max-md:[&_[data-image-layout='left']+p]:min-h-0",
  "max-md:[&_[data-image-layout='right']+p]:min-h-0",
);
